import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EntityTypeId } from 'library-explorer';
import { UserActivityType } from 'src/app/model/enums/user-activity-type.enum';
import { SlideDTO } from 'src/app/model/slideDTO.model';
import { UserActivityService } from 'src/app/services/user-activity.service';

@Component({
    selector: 'app-slide-webinar',
    templateUrl: './slide-webinar.component.html',
    styleUrls: ['./slide-webinar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlideWebinarComponent implements OnInit {
  @Input() public slideData: SlideDTO;

  public readonly activityTypes: typeof UserActivityType = UserActivityType;

  constructor(private readonly userActivityService: UserActivityService) { }

  ngOnInit() {
  }

  public logUserActivity(type: UserActivityType): void {
    this.userActivityService.logUserVideoActivity(type, this.slideData.id, EntityTypeId.NODE, this.slideData.webinar.mediaVideo);
  }

}
